var $f951b0d83789d0a7$exports = {};
(()=>{
    const dialog = document.querySelector('dialog');
    dialog.addEventListener('click', (e)=>{
        const outside = (x, y)=>{
            const { top: top, right: right, bottom: bottom, left: left } = dialog.getBoundingClientRect();
            return y < top || y > bottom || x < left || x > right;
        };
        if (outside(e.clientX, e.clientY)) dialog.close();
    });
    dialog.querySelector('.closer').addEventListener('click', ()=>dialog.close());
    document.querySelector(".indicator")?.addEventListener('click', ()=>{
        dialog.querySelector('.image-pop-alt').textContent = dialog.querySelector('img')?.alt ?? '';
        dialog.showModal();
    });
})();


//# sourceMappingURL=about.95ba8cbf.js.map
